import * as types from './types';
import api from '~/services/api';
import { handleErrors } from '../common';

const getEndpoints = {
  expediteMaterials: {
    url: '/expedite/materials',
    responseObject: 'expedite_materials',
    typeAction: types.SET_EXPEDITE_MATERIALS_LIST,
  },
  expediteDailyParts: {
    url: '/expedite/report',
    responseObject: 'expedite_report',
    typeAction: types.SET_EXPEDITE_DAILY_PARTS_LIST,
  },
};

export const setPaginationValues = values => ({
  type: types.SET_PAGINATION_VALUES,
  payload: values,
});

export const updatePaginationValues = values => ({
  type: types.UPDATE_PAGINATION_VALUES,
  payload: values,
});

export const getAll = ({
  domain,
  filters = {},
  pagination = null,
  reorder = true,
}) => async (dispatch) => {
  try {
    const endpoint = getEndpoints[domain];
    const {
      data: {
        result: {
          [endpoint.responseObject]: data = [],
          total_records: totalRecords = 0,
        },
      },
    } = await api.get(endpoint.url, { params: filters });

    dispatch({ type: endpoint.typeAction, payload: { data, reorder } });

    if (pagination) {
      const paginationData = {
        listType: domain,
        ...pagination,
        total: totalRecords,
        loadingMore: false,
      };
      dispatch(setPaginationValues(paginationData));
    }
  } catch ({ response }) {
    if (response) {
      dispatch(handleErrors(response));
    }
  }
};

export const getExpediteMaterials = () => async (dispatch) => {
  dispatch(getAll({ domain: 'expediteMaterials' }));
};

export const addExpediteMaterial = newMaterial => async (dispatch) => {
  dispatch({
    type: types.ADD_EXPEDITE_MATERIAL,
    payload: newMaterial,
  });
};

export const updateExpediteMaterial = updatedMaterial => async (dispatch) => {
  const updatedStatus = updatedMaterial.update_status || 'U';
  dispatch({
    type: types.UPDATE_EXPEDITE_MATERIAL,
    payload: {
      ...updatedMaterial,
      update_status: updatedStatus,
    },
  });
};

export const saveExpediteMaterials = expediteMaterialsList => async (dispatch) => {
  try {
    if (!expediteMaterialsList || expediteMaterialsList.length === 0) {
      return;
    }

    const items = expediteMaterialsList
      .filter(e => e.update_status)
      .map((e) => {
        const {
          isDirty,
          id,
          ...rest
        } = e;
        if (rest.update_status !== 'I') return { id, ...rest };
        return rest;
      });


    const { status } = await api.post(
      getEndpoints.expediteMaterials.url,
      { expedite_materials: items },
    );
    if (status === 200) {
      dispatch(getExpediteMaterials());
    }
  } catch ({ response }) {
    if (response) {
      dispatch(handleErrors(response));
    }
  }
};

export const resetExpediteMaterials = () => async (dispatch) => {
  dispatch({
    type: types.RESET_EXPEDITE_MATERIALS_LIST,
  });
};

export const getExpediteDailyParts = ({
  parameters,
  page = 0,
  limit = 1500,
  nextBatchPage = 0,
  pageSize = 10,
  reorder = true,
}) => async (dispatch) => {
  const { startDate = null, endDate = null, ...rest } = parameters || {};

  const defaultFilters = {
    page: nextBatchPage > 0 ? nextBatchPage : page,
    limit,
    ...rest,
  };

  dispatch(getAll({
    domain: 'expediteDailyParts',
    filters: defaultFilters,
    pagination: {
      page,
      pageSize,
      batchSize: limit,
    },
    reorder,
  }));
};

export const addExpediteDailyPart = newDailyPart => async (dispatch) => {
  const newData = {
    ...newDailyPart,
    update_status: 'I',
    isDirty: true,
    exception_type: 13,
  };
  dispatch({
    type: types.ADD_EXPEDITE_DAILY_PART,
    payload: newData,
  });
};

export const updateExpediteDailyPart = updatedDailyPart => async (dispatch) => {
  const updatedStatus = updatedDailyPart.update_status || 'U';
  dispatch({
    type: types.UPDATE_EXPEDITE_DAILY_PART,
    payload: {
      ...updatedDailyPart,
      update_status: updatedStatus,
    },
  });
};

export const saveExpediteDailyParts = (
  { expediteDailyPartsList, filters = {}, pagination = {} },
) => async (dispatch) => {
  try {
    if (!expediteDailyPartsList || expediteDailyPartsList.length === 0) {
      return;
    }

    const items = expediteDailyPartsList
      .filter(e => e.update_status)
      .map((e) => {
        const {
          isDirty,
          id,
          ...rest
        } = e;
        if (rest.update_status !== 'I') return { id, ...rest };
        return rest;
      });

    const { status } = await api.post(
      getEndpoints.expediteDailyParts.url,
      { expedite_report: items },
    );
    if (status === 200) {
      dispatch(getExpediteDailyParts({
        parameters: filters,
        page: 0,
        limit: pagination?.batchSize || 1500,
        nextBatchPage: pagination?.nextBatchPage || 0,
        pageSize: pagination?.pageSize || 10,
      }));
    }
  } catch ({ response }) {
    if (response) {
      dispatch(handleErrors(response));
    }
  }
};

export const deleteExpediteDailyPart = deletedDailyPart => async (dispatch) => {
  const deletedStatus = 'D';
  const data = { ...deletedDailyPart, update_status: deletedStatus, isDirty: true };

  dispatch({
    type: types.DELETE_EXPEDITE_DAILY_PART,
    payload: data,
  });
};

export const cleanExpediteDailyPartsList = () => async (dispatch) => {
  dispatch({
    type: types.CLEAN_EXPEDITE_DAILY_PARTS_LIST,
  });
};

export const resetExpediteDailyParts = () => async (dispatch) => {
  dispatch({
    type: types.RESET_EXPEDITE_DAILY_PARTS_LIST,
  });
};

export const setExpediteDailyPartsFilters = filters => async (dispatch) => {
  dispatch({
    type: types.SET_EXPEDITE_DAILY_PARTS_FILTERS,
    payload: filters,
  });
};
